import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import type { SickDaysReportData } from "~/modules/humanResources/api/sickdaysReport/sickdaysReportTypes.ts";

export function getSickDaysReport():AxiosApiResponsePromise<SickDaysReportData>{
	return axiosApi.get('/absences/sick-days-report')
}